import { FunctionComponent } from "react";
import { Route, Routes } from "react-router-dom";

import { ReadyToSend } from "./pages/ReadyToSend/ReadyToSend";
import { Inbox } from "./pages/Inbox/Inbox";
import { Outbox } from "./pages/Outbox/Outbox";
import { MessageSocketProvider } from "./providers/SocketContext";
import { Compose } from "./pages/Compose/Compose";

export const Messages: FunctionComponent = () => {
	return (
		<MessageSocketProvider>
			<Routes>
				<Route element={<Inbox />} path="/inbox" />
				<Route element={<Outbox />} path="/outbox" />
				<Route element={<ReadyToSend />} path="/ready-to-send/:id?" />
				<Route element={<Compose />} path="/compose" />
			</Routes>
		</MessageSocketProvider>
	);
};
